var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormationHalf = _interopRequireDefault(require("./FormationHalf"));

var _FormationSubstitution = _interopRequireDefault(require("./FormationSubstitution"));

var _FormationBench = _interopRequireDefault(require("./FormationBench"));

var _Basic = require("../../../elements/Basic");

var _withDataRefresh = _interopRequireDefault(require("../../../hoc/withDataRefresh"));

var _withDataFetch = _interopRequireDefault(require("../../../hoc/withDataFetch"));

var _FormationReferee = _interopRequireDefault(require("./FormationReferee"));

var _FormationTrainer = _interopRequireDefault(require("./FormationTrainer"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Formation/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Formation = function (_React$Component) {
  (0, _inherits2.default)(Formation, _React$Component);

  var _super = _createSuper(Formation);

  function Formation() {
    (0, _classCallCheck2.default)(this, Formation);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Formation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          formation = _this$props.formation,
          onPlayerPress = _this$props.onPlayerPress,
          refreshing = _this$props.refreshing,
          referee = _this$props.referee,
          onRefresh = _this$props.onRefresh,
          fieldWidth = _this$props.fieldWidth,
          createPlayerHref = _this$props.createPlayerHref,
          NavWrapper = _this$props.NavWrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["formation", "onPlayerPress", "refreshing", "referee", "onRefresh", "fieldWidth", "createPlayerHref", "NavWrapper"]);
      return _react.default.createElement(_Basic.ScrollView, (0, _extends2.default)({}, rest, {
        refreshControl: _react.default.createElement(_Basic.RefreshControl, {
          refreshing: refreshing,
          onRefresh: onRefresh,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 39,
            columnNumber: 33
          }
        }),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37,
          columnNumber: 13
        }
      }), formation && formation.homeTeam && formation.awayTeam ? _react.default.createElement(_Basic.View, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 42,
          columnNumber: 21
        }
      }, formation.homeTeam.system && formation.awayTeam.system ? _react.default.createElement(_Basic.Column, {
        isFlex: true,
        bg: "formation.grass",
        position: "relative",
        height: 500,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44,
          columnNumber: 29
        }
      }, _react.default.createElement(_FormationHalf.default, (0, _extends2.default)({
        formation: formation.homeTeam.formation
      }, formation.homeTeam, {
        onPress: onPlayerPress,
        fieldWidth: fieldWidth,
        createPlayerHref: createPlayerHref,
        NavWrapper: NavWrapper,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 33
        }
      })), formation.homeTeam.formation && formation.homeTeam.formation.length || formation.awayTeam.formation && formation.awayTeam.formation.length ? [_react.default.createElement(_Basic.View, {
        key: "formation_lines_1",
        bg: "formation.lines",
        height: 1,
        opacity: 0.4,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 43
        }
      }), _react.default.createElement(_Basic.View, {
        key: "formation_lines_2",
        borderX: 1,
        borderY: 1,
        borderRadius: 50,
        borderColor: "formation.lines",
        width: "60px",
        height: "60px",
        opacity: 0.4,
        position: "absolute",
        bg: "transparent",
        left: "50%",
        top: "50%",
        mt: "-30px",
        ml: "-30px",
        zIndex: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 64,
          columnNumber: 43
        }
      })] : null, _react.default.createElement(_FormationHalf.default, (0, _extends2.default)({
        formation: formation.awayTeam.formation
      }, formation.awayTeam, {
        onPress: onPlayerPress,
        fieldWidth: fieldWidth,
        createPlayerHref: createPlayerHref,
        NavWrapper: NavWrapper,
        away: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 33
        }
      }))) : _react.default.createElement(_FormationBench.default, {
        benchHome: formation.homeTeam.firstEleven,
        benchAway: formation.awayTeam.firstEleven,
        onPress: onPlayerPress,
        createPlayerHref: createPlayerHref,
        NavWrapper: NavWrapper,
        hideTitle: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 94,
          columnNumber: 29
        }
      }), _react.default.createElement(_FormationSubstitution.default, {
        substitutionHome: formation.homeTeam.substitution,
        substitutionAway: formation.awayTeam.substitution,
        onPress: onPlayerPress,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103,
          columnNumber: 25
        }
      }), _react.default.createElement(_FormationBench.default, {
        benchHome: formation.homeTeam.bench,
        benchAway: formation.awayTeam.bench,
        onPress: onPlayerPress,
        createPlayerHref: createPlayerHref,
        NavWrapper: NavWrapper,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 108,
          columnNumber: 25
        }
      }), _react.default.createElement(_FormationTrainer.default, {
        homeTrainer: formation.homeTeam.trainer,
        awayTrainer: formation.awayTeam.trainer,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115,
          columnNumber: 25
        }
      }), _react.default.createElement(_FormationReferee.default, {
        referee: referee,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119,
          columnNumber: 25
        }
      })) : null);
    }
  }]);
  return Formation;
}(_react.default.Component);

Formation.propTypes = {
  formation: _propTypes.default.object.isRequired,
  referee: _propTypes.default.object,
  onPlayerPress: _propTypes.default.func,
  refreshing: _propTypes.default.bool,
  onRefresh: _propTypes.default.func,
  fieldWidth: _propTypes.default.number,
  NavWrapper: _propTypes.default.func
};

var _default = (0, _withDataFetch.default)((0, _withDataRefresh.default)(Formation));

exports.default = _default;